const style = `
<style>
        ul {
          display: flex;
          position: relative;
          flex-direction: column;
          list-style-type: none;
          padding: 0;
          border-right: 1px solid #c3c7c7;
          border-left: 1px solid #c3c7c7;
          border-bottom:  1px solid #c3c7c7;
          border-radius: 10px;
          width: 100%;
          overflow: hidden;
        }
        ul.close {
          li:not(.selected) {
            display: none;
          }
        }
        li {
          display: flex;
          cursor: pointer;
          padding: 10px 12px;
          cursor: pointer;
          border-top: 1px solid #c3c7c7;
          gap: 12px;
          align-items: center;
          padding: 0px;
          height: 61px;
          overflow: hidden;
        }
        li:hover {
          background-color: #f1f9f7;
        }
        li.selected {
          order: -1;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
        }
        span {
          display: block;
          font-size: 12px;
        }
        .title {
          font-size: 16px;
        }
        .description {
          margin-top: -5px;
        }
        @media (max-width: 767px) {
          .description {
            margin-top: 0px;
            max-width: 285px;
          }
        }
        @media (max-width: 375px) {
          .description {
            max-width: 238px;
          }
        }
        @media (max-width: 360px) {
          .description {
            max-width: 175px;
            line-height: 1.2;
          }
        }
      </style>
`;

export { style };
